import React from "react";
import {
	EnvelopeIcon,
	PhoneIcon,
	MapPinIcon,
} from "@heroicons/react/24/outline";

const ContactDetails = ({iconTheme="text-theme", headerNameTheme="text-theme", valueTheme="text-gray-600"}) => (
	<div className="space-y-6  text-gray-600">
		{/* Email */}
		<div className="flex items-center space-x-4">
			<span className="min-w-5">
				<EnvelopeIcon className={`h-6 w-6 ${iconTheme}`} />
			</span>
			<p className="flex flex-wrap text-ellipsis">
				<span className={`font-semibold mr-1 ${headerNameTheme}`}>Email:</span>
				<span className={`${valueTheme}`}>sacredheartschoolchumoukedima@gmail.com</span>
			</p>
		</div>
		{/* Phone */}
		<div className="flex items-center space-x-4">
			<span className="min-w-5">
				<PhoneIcon className={`h-6 w-6 ${iconTheme}`} />
			</span>
			<p>
				<span className={`font-semibold mr-1 ${headerNameTheme}`}>Phone:</span>
                <span className={`${valueTheme}`}> +91 84148 91204 </span>
			</p>
		</div>
		{/* Address */}
		<div className="flex items-center space-x-4">
			<span className="min-w-5">
				<MapPinIcon className={`h-6 w-6 ${iconTheme}`} />
			</span>
			<p>
				<span className={`font-semibold mr-1 ${headerNameTheme}`}>Address:</span> 
                <span className={`${valueTheme}`}> 5th Mile, Model Village, Chümoukedima - 797115, Nagaland</span>
			</p>
		</div>
	</div>
);

export default ContactDetails;
